const isBrowser = () => typeof window !== 'undefined';

const isGtagReady = () => isBrowser() && typeof window.gtag === 'function';

const log = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.info('[GA]', ...args);
  }
};

export const trackEvent = (eventName, params = {}) => {
  try {
    if (!isGtagReady()) {
      log('gtag not ready:', eventName, params);
      return;
    }

    window.gtag('event', eventName, { ...params, debug_mode: true });
    log('event sent:', eventName, params);
  } catch (error) {
    console.error('[GA ERROR]', eventName, error);
  }
};
